import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import styles from './ConfirmSwitchersChangeDialogContent.module.scss'

interface IProps {
  currCurrency: string
  currActualsValueType: string
  currency: string
  actualsValueType: string
  onConfirm: () => void
  onClose: () => void
}

export const ConfirmSwitchersChangeDialogContent = ({
  currCurrency,
  currActualsValueType,
  currency,
  actualsValueType,
  onConfirm,
  onClose,
}: IProps) => {
  return (
    <div className={styles.root}>
      <WidgetHeader>jbp-switchers-changed-confirm-title</WidgetHeader>
      <p>
        <Translation
          text="jbp-switchers-changed-confirm-info"
          replaceParams={[
            {
              key: '{currCurrency}',
              value: currCurrency,
            },
            {
              key: '{currActualsValueType}',
              value: currActualsValueType,
            },
            {
              key: '{currency}',
              value: currency,
            },
            {
              key: '{actualsValueType}',
              value: actualsValueType,
            },
          ]}
        />
      </p>
      <div className={styles.btns}>
        <Button className={styles.btns__btn} onClick={onConfirm}>
          <Translation text="jbp-switchers-changed-confirm-apply" />
        </Button>
        <Button color="grey" onClick={onClose}>
          <Translation text="jbp-switchers-changed-confirm-cancel" />
        </Button>
      </div>
    </div>
  )
}
